<template>
  <div
    :id="`drop-down-selector-${id}`"
    class="drop-down-selector"
    :class="{ expanded: expanded, accepted: accepted, error: error }"
  >
    <div
      class="d-flex justify-content-between align-items-center field"
      @click="expanded = !expanded"
      @keyup.enter="expanded = !expanded"
      @keydown.down="focusOptionsFirst"
      @keydown.up="focusOptionsLast"
      :tabindex="0"
    >
      <div>
        {{ modelValue || placeholder }}
      </div>
      <div class="d-flex align-items-center">
        <fa icon="exclamation" class="exclamation" />
        <div
          class="caret"
          :class="[expanded ? 'caret-up' : 'caret-down']"
        ></div>
      </div>
    </div>
    <div v-if="expanded" class="item-box">
      <div
        class="item"
        v-for="element in elements"
        :key="element.value"
        @click="
          updateValue(element.value);
          expanded = false;
        "
        @keyup.enter="
          updateValue(element.value);
          expanded = false;
        "
        @keydown.down="optionsDown"
        @keydown.up="optionsUp"
        :tabindex="0"
      >
        {{ element.label }}
      </div>
    </div>
    <small class="error-msg">{{ errorMsg }}</small>
  </div>
</template>
<script>
export default {
  name: "dropdown-selector",
  props: {
    modelValue: String,
    placeholder: String,
    elements: Array,
    state: String,
    id: String,
  },
  computed: {
    accepted() {
      return this.state && this.state.startsWith("ACCEPTED");
    },
    error() {
      return this.state && this.state.startsWith("ERROR");
    },
    errorMsg() {
      return this.error && this.state.split("ERROR").pop();
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    updateValue(value) {
      this.$emit("update:modelValue", value);
    },
    focusOptionsFirst(e) {
      e.preventDefault();
      const options = document
        .getElementById(`drop-down-selector-${this.id}`)
        .getElementsByClassName("item");
      if (options && options.length > 0) {
        options[0].focus();
      }
    },
    focusOptionsLast(e) {
      e.preventDefault();
      const options = document
        .getElementById(`drop-down-selector-${this.id}`)
        .getElementsByClassName("item");
      if (options && options.length > 0) {
        options[options.length - 1].focus();
      }
    },
    optionsDown(e) {
      e.preventDefault();
      if (e.target.nextElementSibling?.classList.contains("item")) {
        e.target.nextElementSibling?.focus();
      } else {
        const options = document
          .getElementById(`drop-down-selector-${this.id}`)
          .getElementsByClassName("item");
        if (options && options.length > 0) {
          options[0].focus();
        }
      }
    },
    optionsUp(e) {
      e.preventDefault();
      if (e.target.previousElementSibling?.classList.contains("item")) {
        e.target.previousElementSibling?.focus();
      } else {
        const options = document
          .getElementById(`drop-down-selector-${this.id}`)
          .getElementsByClassName("item");
        if (options && options.length > 0) {
          options[options.length - 1].focus();
        }
      }
    },
  },
  mounted() {
    document.addEventListener("click", (e) => {
      if (
        !document
          .getElementById(`drop-down-selector-${this.id}`)
          ?.contains(e.target)
      ) {
        this.expanded = false;
      }
    });
    document.addEventListener("keyup", (e) => {
      if (
        e.key === "Tab" &&
        !document
          .getElementById(`drop-down-selector-${this.id}`)
          ?.contains(e.target)
      ) {
        this.expanded = false;
      }
    });
  },
};
</script>
